import { useParams, Link, Navigate } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { FadeIn } from '../components/ui/AnimatedSection';
import { useTranslation } from 'react-i18next';
import type { Article as ArticleType } from '../data/blog';

export default function Article() {
  const { id } = useParams();
  const { t } = useTranslation();
  const blogArticles = t('blog.articles', { returnObjects: true }) as ArticleType[];
  const article = blogArticles.find(a => a.id === id);

  if (!article) {
    return <Navigate to="/realisations" replace />;
  }

  // Formatting content with paragraphs
  const contentParagraphs = article.content.split('\n\n');

  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      
      <main className="flex-grow pt-32 pb-24">
        <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <FadeIn className="text-center mb-16">
            <span className="text-gold-500 text-sm font-bold uppercase tracking-widest mb-4 block">
              {article.category} • {article.date}
            </span>
            <h1 className="text-4xl md:text-6xl font-serif text-black-deep mb-8 leading-tight">
              {article.title}
            </h1>
            <div className="w-16 h-px bg-gold-400 mx-auto"></div>
          </FadeIn>

          <FadeIn delay={0.2} className="mb-16">
            <div className="relative h-[50vh] min-h-[400px] w-full rounded-sm overflow-hidden shadow-2xl">
              <img 
                src={article.image} 
                alt={article.title} 
                className="w-full h-full object-cover"
              />
            </div>
          </FadeIn>

          <FadeIn delay={0.4} className="prose prose-lg prose-gold max-w-2xl mx-auto">
            <p className="text-xl font-light text-gray-600 mb-10 leading-relaxed italic">
              {article.excerpt}
            </p>
            
            {contentParagraphs.map((p, idx) => (
              <p key={idx} className="text-gray-700 font-light leading-loose mb-6">
                {p}
              </p>
            ))}

            <div className="mt-16 pt-8 border-t border-gray-200 text-center">
              <Link to="/realisations" className="text-sm uppercase tracking-widest font-bold text-black-deep hover:text-gold-500 transition-colors">
                &larr; {t('blog.backToBlog')}
              </Link>
            </div>
          </FadeIn>

        </article>
      </main>

      <Footer />
    </div>
  );
}
